export class PresentationConstants {
    static readonly mobileMaxWidthPx = 768;
    static readonly imagePrefix = {
        "desktop": {
            "productDetail": "?width=800&dpr=2&quality=90",
            "productOthers": "?width=300&dpr=2&quality=75",
            "productCarousel": "?width=200&dpr=2&quality=75",
            "othersImage": "?width=500&dpr=2&quality=75",
            "catalog": "?width=300&dpr=2&quality=75",
        },
        "mobile": {
            "productDetail": "?width=600&dpr=2&quality=90",
            "productOthers": "?width=300&dpr=2&quality=75",
            "productCarousel": "?width=200&dpr=2&quality=75",
            "othersImage": "?width=300&dpr=2&quality=75",
            "catalog": "?width=200&dpr=2&quality=75"
        }
    };
}
